import React, { ReactNode, useEffect, useState } from 'react';

import { PlayerAssetUrls } from '@vimeo/core/AppTypes';

import { PlayerLoader, PlayerType } from './PlayerLoader';

interface Context {
  PlayerConstructor: any;
  playerType: PlayerType | undefined;
}

export const PlayerContext = React.createContext<Context>({
  PlayerConstructor: undefined,
  playerType: undefined,
});

interface Props {
  type: PlayerType;
  assetUrls: PlayerAssetUrls;
  children: ReactNode;
}

/**
 * Player context provider which is responsible for loading the required player assets to DOM
 * and cleaninup on unmounting. After all the assets are loaded a promise is set on the context
 * which could be accessed from any child component.
 */
export default function PlayerContextProvider({ type, assetUrls, children }: Props) {
  const [state, setState] = useState<Context>({
    PlayerConstructor: undefined,
    playerType: undefined,
  });

  useEffect(() => {
    const playerLoader = new PlayerLoader(type, assetUrls);
    playerLoader.load().then(() => {
      setState({ PlayerConstructor: window[PlayerType[type]], playerType: type });
    });
    return () => {
      if (playerLoader) {
        playerLoader.cleanup();
      }
    };
  }, [assetUrls, type]);

  return <PlayerContext.Provider value={state}>{children}</PlayerContext.Provider>;
}
